// Copyright (c) 2020-2023 dātma, inc™
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { searchBaseUrl } from '@/settings'


export async function search(query) {
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }
    const url = `${searchBaseUrl}?query=${encodeURIComponent(query)}`
    const response = await fetchWithTimeout(url, fetchParams)
    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }
    const result = await response.json()
    if (!result || !result.results || result.results.length === 0) { return [] }
    // Translate the response to the format expected by the frontend.
    return result.results.map((r) => {
      if (r.uuid) {  // patient search v1
        const birthdate = r.date
        const id = r.value
        const parts = r.uuid.split(',')
        const family = (parts[0] || 'unknown').trim()
        const given = (parts[1] || '').trim()
        const name = `${family || '—'}, ${given || '—'}`
        const gender = r.desc
        return { birthdate, id, name, gender, family, given }
      }

      // patient search v2
      const birthdate = r.birthdate
      const organization = localStorage.getItem('organization')
      const id = r.MRN
      const family = r.family || ''
      const given = r.given || ''
      const name = `${family || '—'}, ${given || '—'}`
      const gender = r.gender || ''
      // patient search v3
      const age = r.age || -1
      const middle = r.middle || ''
      const mortalityStatus = r.mortality_status || ''
      const postalCode = r.postal_code || ''
      return { age, birthdate, family, gender, given, id, middle, mortalityStatus, name, organization, postalCode }
    })
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}
